/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DiscordRelayMessageMessageAuthor
 */
export interface DiscordRelayMessageMessageAuthor {
    /**
     * 
     * @type {string}
     * @memberof DiscordRelayMessageMessageAuthor
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscordRelayMessageMessageAuthor
     */
    username?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscordRelayMessageMessageAuthor
     */
    discriminator?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscordRelayMessageMessageAuthor
     */
    avatar?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DiscordRelayMessageMessageAuthor
     */
    bot?: boolean;
}

export function DiscordRelayMessageMessageAuthorFromJSON(json: any): DiscordRelayMessageMessageAuthor {
    return DiscordRelayMessageMessageAuthorFromJSONTyped(json, false);
}

export function DiscordRelayMessageMessageAuthorFromJSONTyped(json: any, ignoreDiscriminator: boolean): DiscordRelayMessageMessageAuthor {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'username': !exists(json, 'username') ? undefined : json['username'],
        'discriminator': !exists(json, 'discriminator') ? undefined : json['discriminator'],
        'avatar': !exists(json, 'avatar') ? undefined : json['avatar'],
        'bot': !exists(json, 'bot') ? undefined : json['bot'],
    };
}

export function DiscordRelayMessageMessageAuthorToJSON(value?: DiscordRelayMessageMessageAuthor | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'username': value.username,
        'discriminator': value.discriminator,
        'avatar': value.avatar,
        'bot': value.bot,
    };
}


